import React, { Component } from "react";
import $ from "jquery";
import _ from "lodash";

import { Translate, I18n } from "react-redux-i18n";

import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";

import UserCard from "../../utils/components/UserCard";
import AddUsersByPhone from "../../utils/components/AddUsersByPhone";

import { compressImage } from "../../utils/Utils";

import "../../../styles/components/evs/modals/AddGroup.scss";
import friends from "../../../styles/images/friends.svg";
import camera from "../../../styles/images/camera.svg";
import plus from "../../../styles/images/plus.svg";

class AddGroup extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;

    this.state = {
      validated: false,

      groupPicture: null,
      name: "",
      users: [],

      modals: {
        add: false,
      },
    };

    this.handlePickPicture = this.handlePickPicture.bind(this);
    this.handlePictureChange = this.handlePictureChange.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleAddUsers = this.handleAddUsers.bind(this);
    this.handleDeleteUser = this.handleDeleteUser.bind(this);
    this.handleOnSubmit = this.handleOnSubmit.bind(this);
    this.resetState = this.resetState.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  handlePickPicture(e) {
    document.getElementById("file-picker").click();
  }

  handlePictureChange(e) {
    let file = e.target.files && e.target.files[0];

    compressImage(file).then(groupPicture => {
      this.safeSetState({ groupPicture });
    });
  }

  handleOnChange(e) {
    this.safeSetState({
      [e.target.name]: e.target.value,
    });
  }

  handleAddUsers(users) {
    const newUsers = users.map(user =>
      Object.assign({}, user, {
        mobile: user.mobile || user.phone.replace(/[^0-9]+/g, "").slice(user.prefix.length),
        internationalPrefix: user.internationalPrefix || "+" + user.prefix,
      })
    );
    this.safeSetState(
      prevState => ({
        users: _.unionBy(prevState.users, newUsers, "mobile"),
      }),
      () => this.setModal("add", false)
    );
  }

  handleDeleteUser(e, idx) {
    this.safeSetState(prevState => ({
      users: [...prevState.users.slice(0, idx), ...prevState.users.slice(idx + 1)],
    }));
  }

  handleOnSubmit(e) {
    e.preventDefault();
    const form = $(e.target)[0];
    this.safeSetState({ validated: true }, () => {
      if (form.checkValidity() !== false) {
        this.props.onSubmit(
          form.elements,
          this.state.groupPicture,
          this.state.users.map(u => ({
            userId: u._id,
            name: u.name,
            mobile: u.mobile || u.phone.replace(/[^0-9]+/g, "").slice(u.prefix.length),
            internationalPrefix: u.internationalPrefix || "+" + u.prefix,
          }))
        );
      }
    });
  }

  resetState() {
    this.safeSetState({
      validated: false,
      groupPicture: friends,
      name: "",
      users: [],
    });
  }

  setModal(modal, bool) {
    let newModals = Object.assign({}, this.state.modals);
    newModals[modal] = bool;
    this.safeSetState({
      modals: newModals,
    });
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <>
        <Modal
          id="addGroup"
          show={this.props.show}
          onHide={this.props.onHide}
          onExited={this.resetState}
          centered
        >
          <Modal.Header>
            <Modal.Title>
              <Translate value="drivers_addGroup" />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="picture-picker-container">
              <input
                id="file-picker"
                type="file"
                accept="image/*"
                onChange={this.handlePictureChange}
              />
              <button type="button" className="picture-picker" onClick={this.handlePickPicture}>
                <img id="picture" src={this.state.groupPicture} alt="avatar" />
                <img src={camera} className="camera" alt="" />
              </button>
            </div>
            <Form
              id="add-group-form"
              onSubmit={this.handleOnSubmit}
              validated={this.state.validated}
              noValidate
            >
              <Form.Group className="form-field">
                <Form.Label>
                  <Translate value="drivers_groupName" />
                </Form.Label>
                <Form.Control
                  type="text"
                  name="groupName"
                  placeholder={I18n.t("drivers_groupNameExample")}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  <Translate value="addGroup_invalidGroupName" />
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="form-field">
                {this.state.users.map((u, idx) => (
                  <UserCard
                    key={idx}
                    type="info"
                    avatar={u.imageContent}
                    name={u.name || ""}
                    info={`${u.internationalPrefix || "+" + u.prefix} ${u.mobile || u.phone.replace(/[^0-9]+/g, "").slice(u.prefix.length)
                      }`}
                    onDelete={e => this.handleDeleteUser(e, idx)}
                  />
                ))}
              </Form.Group>
              <Form.Group className="form-field">
                <button type="button" className="clear" onClick={() => this.setModal("add", true)}>
                  <img src={plus} alt="" />
                  <Translate value="drivers_addUser" />
                </button>
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <button type="submit" form="add-group-form">
              <Translate value="drivers_add" />
            </button>
          </Modal.Footer>
        </Modal>

        <AddUsersByPhone
          show={this.state.modals.add}
          onHide={() => this.setModal("add", false)}
          onSubmit={this.handleAddUsers}
        />
      </>
    );
  }
}

export default AddGroup;
